import React from 'react';
import styles from '../TranslationsAccordion.module.scss';

interface RegularTabContentProps {
  translations: any;
  defaultLanguage: string;
  contentComment: (comment: string, length: number) => JSX.Element;
}

const RegularTabContent: React.FC<RegularTabContentProps> = (props) => {
  const { translations, defaultLanguage, contentComment = () => {} } = props;

  return (
    <>
      { Object.values(translations).map((content: any) => (
        <div className={styles.FormContent}>
          {Object.keys(content).map((comment: string):any => {
            if (content[comment].translations[defaultLanguage] !== '') {
              return (
                contentComment(comment, content[comment].length)
              );
            }

            return null;
          })}
        </div>
      ))}
    </>
  );
};

export default RegularTabContent;
